import { useApiAction } from '../action/useApiAction'
// eslint-disable-next-line import/no-unresolved
import { postCrmInvitationsAcceptMe } from 'data-api'

export const useRewardInvitationConfirm = () => {
	const { action, loading, error } = useApiAction({
		method: postCrmInvitationsAcceptMe,
	})

	return {
		action,
		loading,
		error,
	}
}
